import { useSearchDateShortcut } from '@/hooks/useSearch'
import { secondToString } from '@/utils/date-format'
import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { StatisticalDeptRecord } from './statistical-dept.service'

export function createStatisticalDeptSearchItems(
  channelOptions: CrudSelectOption[],
  departmentOptions: CrudSelectOption[],
  optionsLoading: boolean
): CrudSearchItem[] {
  const controlClass = 'statistical-dept-page__search-control'

  return [
    {
      label: '直播间',
      prop: 'channelId',
      type: 'select',
      controlClass,
      clearable: true,
      loading: optionsLoading,
      placeholder: '请选择直播间',
      options: channelOptions
    },
    {
      label: '部门',
      prop: 'deptId',
      type: 'select',
      controlClass,
      clearable: true,
      placeholder: '请选择部门',
      options: departmentOptions
    },
    {
      label: '访问时间',
      prop: 'accessTime',
      type: 'dateTimeRange',
      controlClass,
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      shortcuts: useSearchDateShortcut(),
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      disabledDate: (date) => date.getTime() > Date.now()
    }
  ]
}

export const statisticalDeptTableColumns: CrudTableColumn<StatisticalDeptRecord>[] =
  [
    {
      prop: 'deptName',
      label: '部门名称',
      minWidth: 80,
      showOverflowTooltip: true
    },
    {
      prop: 'channelName',
      label: '直播间',
      minWidth: 120,
      showOverflowTooltip: true
    },
    { prop: 'pv', label: '访问次数(pv)', minWidth: 80 },
    { prop: 'uv', label: '客户数量(uv)', minWidth: 80 },
    { prop: 'ip', label: 'ip数量', minWidth: 80 },
    {
      prop: 'duration',
      label: '访问总时长(min)',
      minWidth: 120,
      formatter: (row) => secondToString(row.duration)
    }
  ]
